<template>
  <footer class="app-footer">
    <div class="footer-container">
      <div class="footer-content">
        <span class="footer-copyright">
          © {{ currentYear }} {{ footer.copyrightName }}
        </span>
        <span class="footer-divider">|</span>
        <a
          v-if="footer.copyrightLink"
          :href="footer.copyrightLink"
          target="_blank"
          rel="noopener noreferrer"
          class="footer-link"
        >
          {{ displayLink }}
        </a>
        <span class="footer-divider">|</span>
        <a
          href="https://neffico.com/"
          target="_blank"
          rel="noopener noreferrer"
          class="footer-powered"
        >
          IT support by Neffico
        </a>
      </div>
    </div>
  </footer>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useSiteConfig } from '@/composables/useSiteConfig'

const { footer } = useSiteConfig()
const currentYear = computed(() => new Date().getFullYear())

// Remove https:// or http:// prefix for display
const displayLink = computed(() => {
  if (!footer.value.copyrightLink) return ''
  return footer.value.copyrightLink.replace(/^https?:\/\//, '')
})
</script>

<style scoped>
.app-footer {
  background: var(--bg-dark);
  color: var(--text-light);
  padding: 1rem 0;
  margin-top: auto;
  box-shadow: 0 -1px 3px rgba(0, 0, 0, 0.15);
}

.footer-container {
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 1.5rem;
}

.footer-content {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
}

.footer-copyright {
  font-size: 0.875rem;
  color: var(--text-light);
  opacity: 0.9;
}

.footer-divider {
  color: var(--text-light);
  opacity: 0.4;
  font-size: 0.875rem;
}

.footer-link {
  color: var(--text-light);
  text-decoration: none;
  font-size: 0.875rem;
  opacity: 0.9;
  transition: opacity 0.2s;
}

.footer-link:hover {
  opacity: 1;
  text-decoration: underline;
}

.footer-powered {
  font-size: 0.875rem;
  color: var(--text-light);
  opacity: 0.6;
  text-decoration: none;
  transition: opacity 0.2s;
}

.footer-powered:hover {
  opacity: 0.9;
  text-decoration: underline;
}

/* Mobile responsive - stack vertically on small screens */
@media (max-width: 480px) {
  .footer-content {
    flex-direction: column;
    gap: 0.5rem;
  }

  .footer-divider {
    display: none;
  }
}
</style>
